module.exports = __webpack_public_path__ + "static/timemachine-logo-0c20a276b6977a96b0e681fa612a63e2.svg";